export const countriesList = [
  {
    key: 'Afghanistan',
    dialCode: '+93',
    value: 'AF',
  },
  {
    key: 'Aland Islands',
    dialCode: '+358',
    value: 'AX',
  },
  {
    key: 'Albania',
    dialCode: '+355',
    value: 'AL',
  },
  {
    key: 'Algeria',
    dialCode: '+213',
    value: 'DZ',
  },
  {
    key: 'AmericanSamoa',
    dialCode: '+1684',
    value: 'AS',
  },
  {
    key: 'Andorra',
    dialCode: '+376',
    value: 'AD',
  },
  {
    key: 'Angola',
    dialCode: '+244',
    value: 'AO',
  },
  {
    key: 'Anguilla',
    dialCode: '+1264',
    value: 'AI',
  },
  {
    key: 'Antarctica',
    dialCode: '+672',
    value: 'AQ',
  },
  {
    key: 'Antigua and Barbuda',
    dialCode: '+1268',
    value: 'AG',
  },
  {
    key: 'Argentina',
    dialCode: '+54',
    value: 'AR',
  },
  {
    key: 'Armenia',
    dialCode: '+374',
    value: 'AM',
  },
  {
    key: 'Aruba',
    dialCode: '+297',
    value: 'AW',
  },
  {
    key: 'Australia',
    dialCode: '+61',
    value: 'AU',
  },
  {
    key: 'Austria',
    dialCode: '+43',
    value: 'AT',
  },
  {
    key: 'Azerbaijan',
    dialCode: '+994',
    value: 'AZ',
  },
  {
    key: 'Bahamas',
    dialCode: '+1242',
    value: 'BS',
  },
  {
    key: 'Bahrain',
    dialCode: '+973',
    value: 'BH',
  },
  {
    key: 'Bangladesh',
    dialCode: '+880',
    value: 'BD',
  },
  {
    key: 'Barbados',
    dialCode: '+1246',
    value: 'BB',
  },
  {
    key: 'Belarus',
    dialCode: '+375',
    value: 'BY',
  },
  {
    key: 'Belgium',
    dialCode: '+32',
    value: 'BE',
  },
  {
    key: 'Belize',
    dialCode: '+501',
    value: 'BZ',
  },
  {
    key: 'Benin',
    dialCode: '+229',
    value: 'BJ',
  },
  {
    key: 'Bermuda',
    dialCode: '+1441',
    value: 'BM',
  },
  {
    key: 'Bhutan',
    dialCode: '+975',
    value: 'BT',
  },
  {
    key: 'Bolivia, Plurinational State of',
    dialCode: '+591',
    value: 'BO',
  },
  {
    key: 'Bosnia and Herzegovina',
    dialCode: '+387',
    value: 'BA',
  },
  {
    key: 'Botswana',
    dialCode: '+267',
    value: 'BW',
  },
  {
    key: 'Brazil',
    dialCode: '+55',
    value: 'BR',
  },
  {
    key: 'British Indian Ocean Territory',
    dialCode: '+246',
    value: 'IO',
  },
  {
    key: 'Brunei Darussalam',
    dialCode: '+673',
    value: 'BN',
  },
  {
    key: 'Bulgaria',
    dialCode: '+359',
    value: 'BG',
  },
  {
    key: 'Burkina Faso',
    dialCode: '+226',
    value: 'BF',
  },
  {
    key: 'Burundi',
    dialCode: '+257',
    value: 'BI',
  },
  {
    key: 'Cambodia',
    dialCode: '+855',
    value: 'KH',
  },
  {
    key: 'Cameroon',
    dialCode: '+237',
    value: 'CM',
  },
  {
    key: 'Canada',
    dialCode: '+1',
    value: 'CA',
  },
  {
    key: 'Cape Verde',
    dialCode: '+238',
    value: 'CV',
  },
  {
    key: 'Cayman Islands',
    dialCode: '+ 345',
    value: 'KY',
  },
  {
    key: 'Central African Republic',
    dialCode: '+236',
    value: 'CF',
  },
  {
    key: 'Chad',
    dialCode: '+235',
    value: 'TD',
  },
  {
    key: 'Chile',
    dialCode: '+56',
    value: 'CL',
  },
  {
    key: 'China',
    dialCode: '+86',
    value: 'CN',
  },
  {
    key: 'Christmas Island',
    dialCode: '+61',
    value: 'CX',
  },
  {
    key: 'Cocos (Keeling) Islands',
    dialCode: '+61',
    value: 'CC',
  },
  {
    key: 'Colombia',
    dialCode: '+57',
    value: 'CO',
  },
  {
    key: 'Comoros',
    dialCode: '+269',
    value: 'KM',
  },
  {
    key: 'Congo',
    dialCode: '+242',
    value: 'CG',
  },
  {
    key: 'Congo, The Democratic Republic of the Congo',
    dialCode: '+243',
    value: 'CD',
  },
  {
    key: 'Cook Islands',
    dialCode: '+682',
    value: 'CK',
  },
  {
    key: 'Costa Rica',
    dialCode: '+506',
    value: 'CR',
  },
  {
    key: "Cote d'Ivoire",
    dialCode: '+225',
    value: 'CI',
  },
  {
    key: 'Croatia',
    dialCode: '+385',
    value: 'HR',
  },
  {
    key: 'Cuba',
    dialCode: '+53',
    value: 'CU',
  },
  {
    key: 'Cyprus',
    dialCode: '+357',
    value: 'CY',
  },
  {
    key: 'Czech Republic',
    dialCode: '+420',
    value: 'CZ',
  },
  {
    key: 'Denmark',
    dialCode: '+45',
    value: 'DK',
  },
  {
    key: 'Djibouti',
    dialCode: '+253',
    value: 'DJ',
  },
  {
    key: 'Dominica',
    dialCode: '+1767',
    value: 'DM',
  },
  {
    key: 'Dominican Republic',
    dialCode: '+1849',
    value: 'DO',
  },
  {
    key: 'Ecuador',
    dialCode: '+593',
    value: 'EC',
  },
  {
    key: 'Egypt',
    dialCode: '+20',
    value: 'EG',
  },
  {
    key: 'El Salvador',
    dialCode: '+503',
    value: 'SV',
  },
  {
    key: 'Equatorial Guinea',
    dialCode: '+240',
    value: 'GQ',
  },
  {
    key: 'Eritrea',
    dialCode: '+291',
    value: 'ER',
  },
  {
    key: 'Estonia',
    dialCode: '+372',
    value: 'EE',
  },
  {
    key: 'Ethiopia',
    dialCode: '+251',
    value: 'ET',
  },
  {
    key: 'Falkland Islands (Malvinas)',
    dialCode: '+500',
    value: 'FK',
  },
  {
    key: 'Faroe Islands',
    dialCode: '+298',
    value: 'FO',
  },
  {
    key: 'Fiji',
    dialCode: '+679',
    value: 'FJ',
  },
  {
    key: 'Finland',
    dialCode: '+358',
    value: 'FI',
  },
  {
    key: 'France',
    dialCode: '+33',
    value: 'FR',
  },
  {
    key: 'French Guiana',
    dialCode: '+594',
    value: 'GF',
  },
  {
    key: 'French Polynesia',
    dialCode: '+689',
    value: 'PF',
  },
  {
    key: 'Gabon',
    dialCode: '+241',
    value: 'GA',
  },
  {
    key: 'Gambia',
    dialCode: '+220',
    value: 'GM',
  },
  {
    key: 'Georgia',
    dialCode: '+995',
    value: 'GE',
  },
  {
    key: 'Germany',
    dialCode: '+49',
    value: 'DE',
  },
  {
    key: 'Ghana',
    dialCode: '+233',
    value: 'GH',
  },
  {
    key: 'Gibraltar',
    dialCode: '+350',
    value: 'GI',
  },
  {
    key: 'Greece',
    dialCode: '+30',
    value: 'GR',
  },
  {
    key: 'Greenland',
    dialCode: '+299',
    value: 'GL',
  },
  {
    key: 'Grenada',
    dialCode: '+1473',
    value: 'GD',
  },
  {
    key: 'Guadeloupe',
    dialCode: '+590',
    value: 'GP',
  },
  {
    key: 'Guam',
    dialCode: '+1671',
    value: 'GU',
  },
  {
    key: 'Guatemala',
    dialCode: '+502',
    value: 'GT',
  },
  {
    key: 'Guernsey',
    dialCode: '+44',
    value: 'GG',
  },
  {
    key: 'Guinea',
    dialCode: '+224',
    value: 'GN',
  },
  {
    key: 'Guinea-Bissau',
    dialCode: '+245',
    value: 'GW',
  },
  {
    key: 'Guyana',
    dialCode: '+595',
    value: 'GY',
  },
  {
    key: 'Haiti',
    dialCode: '+509',
    value: 'HT',
  },
  {
    key: 'Holy See (Vatican City State)',
    dialCode: '+379',
    value: 'VA',
  },
  {
    key: 'Honduras',
    dialCode: '+504',
    value: 'HN',
  },
  {
    key: 'Hong Kong',
    dialCode: '+852',
    value: 'HK',
  },
  {
    key: 'Hungary',
    dialCode: '+36',
    value: 'HU',
  },
  {
    key: 'Iceland',
    dialCode: '+354',
    value: 'IS',
  },
  {
    key: 'India',
    dialCode: '+91',
    value: 'IN',
  },
  {
    key: 'Indonesia',
    dialCode: '+62',
    value: 'ID',
  },
  {
    key: 'Iran, Islamic Republic of Persian Gulf',
    dialCode: '+98',
    value: 'IR',
  },
  {
    key: 'Iraq',
    dialCode: '+964',
    value: 'IQ',
  },
  {
    key: 'Ireland',
    dialCode: '+353',
    value: 'IE',
  },
  {
    key: 'Isle of Man',
    dialCode: '+44',
    value: 'IM',
  },
  {
    key: 'Israel',
    dialCode: '+972',
    value: 'IL',
  },
  {
    key: 'Italy',
    dialCode: '+39',
    value: 'IT',
  },
  {
    key: 'Jamaica',
    dialCode: '+1876',
    value: 'JM',
  },
  {
    key: 'Japan',
    dialCode: '+81',
    value: 'JP',
  },
  {
    key: 'Jersey',
    dialCode: '+44',
    value: 'JE',
  },
  {
    key: 'Jordan',
    dialCode: '+962',
    value: 'JO',
  },
  {
    key: 'Kazakhstan',
    dialCode: '+77',
    value: 'KZ',
  },
  {
    key: 'Kenya',
    dialCode: '+254',
    value: 'KE',
  },
  {
    key: 'Kiribati',
    dialCode: '+686',
    value: 'KI',
  },
  {
    key: "Korea, Democratic People's Republic of Korea",
    dialCode: '+850',
    value: 'KP',
  },
  {
    key: 'Korea, Republic of South Korea',
    dialCode: '+82',
    value: 'KR',
  },
  {
    key: 'Kuwait',
    dialCode: '+965',
    value: 'KW',
  },
  {
    key: 'Kyrgyzstan',
    dialCode: '+996',
    value: 'KG',
  },
  {
    key: 'Laos',
    dialCode: '+856',
    value: 'LA',
  },
  {
    key: 'Latvia',
    dialCode: '+371',
    value: 'LV',
  },
  {
    key: 'Lebanon',
    dialCode: '+961',
    value: 'LB',
  },
  {
    key: 'Lesotho',
    dialCode: '+266',
    value: 'LS',
  },
  {
    key: 'Liberia',
    dialCode: '+231',
    value: 'LR',
  },
  {
    key: 'Libyan Arab Jamahiriya',
    dialCode: '+218',
    value: 'LY',
  },
  {
    key: 'Liechtenstein',
    dialCode: '+423',
    value: 'LI',
  },
  {
    key: 'Lithuania',
    dialCode: '+370',
    value: 'LT',
  },
  {
    key: 'Luxembourg',
    dialCode: '+352',
    value: 'LU',
  },
  {
    key: 'Macao',
    dialCode: '+853',
    value: 'MO',
  },
  {
    key: 'Macedonia',
    dialCode: '+389',
    value: 'MK',
  },
  {
    key: 'Madagascar',
    dialCode: '+261',
    value: 'MG',
  },
  {
    key: 'Malawi',
    dialCode: '+265',
    value: 'MW',
  },
  {
    key: 'Malaysia',
    dialCode: '+60',
    value: 'MY',
  },
  {
    key: 'Maldives',
    dialCode: '+960',
    value: 'MV',
  },
  {
    key: 'Mali',
    dialCode: '+223',
    value: 'ML',
  },
  {
    key: 'Malta',
    dialCode: '+356',
    value: 'MT',
  },
  {
    key: 'Marshall Islands',
    dialCode: '+692',
    value: 'MH',
  },
  {
    key: 'Martinique',
    dialCode: '+596',
    value: 'MQ',
  },
  {
    key: 'Mauritania',
    dialCode: '+222',
    value: 'MR',
  },
  {
    key: 'Mauritius',
    dialCode: '+230',
    value: 'MU',
  },
  {
    key: 'Mayotte',
    dialCode: '+262',
    value: 'YT',
  },
  {
    key: 'Mexico',
    dialCode: '+52',
    value: 'MX',
  },
  {
    key: 'Micronesia, Federated States of Micronesia',
    dialCode: '+691',
    value: 'FM',
  },
  {
    key: 'Moldova',
    dialCode: '+373',
    value: 'MD',
  },
  {
    key: 'Monaco',
    dialCode: '+377',
    value: 'MC',
  },
  {
    key: 'Mongolia',
    dialCode: '+976',
    value: 'MN',
  },
  {
    key: 'Montenegro',
    dialCode: '+382',
    value: 'ME',
  },
  {
    key: 'Montserrat',
    dialCode: '+1664',
    value: 'MS',
  },
  {
    key: 'Morocco',
    dialCode: '+212',
    value: 'MA',
  },
  {
    key: 'Mozambique',
    dialCode: '+258',
    value: 'MZ',
  },
  {
    key: 'Myanmar',
    dialCode: '+95',
    value: 'MM',
  },
  {
    key: 'Namibia',
    dialCode: '+264',
    value: 'NA',
  },
  {
    key: 'Nauru',
    dialCode: '+674',
    value: 'NR',
  },
  {
    key: 'Nepal',
    dialCode: '+977',
    value: 'NP',
  },
  {
    key: 'Netherlands',
    dialCode: '+31',
    value: 'NL',
  },
  {
    key: 'Netherlands Antilles',
    dialCode: '+599',
    value: 'AN',
  },
  {
    key: 'New Caledonia',
    dialCode: '+687',
    value: 'NC',
  },
  {
    key: 'New Zealand',
    dialCode: '+64',
    value: 'NZ',
  },
  {
    key: 'Nicaragua',
    dialCode: '+505',
    value: 'NI',
  },
  {
    key: 'Niger',
    dialCode: '+227',
    value: 'NE',
  },
  {
    key: 'Nigeria',
    dialCode: '+234',
    value: 'NG',
  },
  {
    key: 'Niue',
    dialCode: '+683',
    value: 'NU',
  },
  {
    key: 'Norfolk Island',
    dialCode: '+672',
    value: 'NF',
  },
  {
    key: 'Northern Mariana Islands',
    dialCode: '+1670',
    value: 'MP',
  },
  {
    key: 'Norway',
    dialCode: '+47',
    value: 'NO',
  },
  {
    key: 'Oman',
    dialCode: '+968',
    value: 'OM',
  },
  {
    key: 'Pakistan',
    dialCode: '+92',
    value: 'PK',
  },
  {
    key: 'Palau',
    dialCode: '+680',
    value: 'PW',
  },
  {
    key: 'Palestinian Territory, Occupied',
    dialCode: '+970',
    value: 'PS',
  },
  {
    key: 'Panama',
    dialCode: '+507',
    value: 'PA',
  },
  {
    key: 'Papua New Guinea',
    dialCode: '+675',
    value: 'PG',
  },
  {
    key: 'Paraguay',
    dialCode: '+595',
    value: 'PY',
  },
  {
    key: 'Peru',
    dialCode: '+51',
    value: 'PE',
  },
  {
    key: 'Philippines',
    dialCode: '+63',
    value: 'PH',
  },
  {
    key: 'Pitcairn',
    dialCode: '+872',
    value: 'PN',
  },
  {
    key: 'Poland',
    dialCode: '+48',
    value: 'PL',
  },
  {
    key: 'Portugal',
    dialCode: '+351',
    value: 'PT',
  },
  {
    key: 'Puerto Rico',
    dialCode: '+1939',
    value: 'PR',
  },
  {
    key: 'Qatar',
    dialCode: '+974',
    value: 'QA',
  },
  {
    key: 'Romania',
    dialCode: '+40',
    value: 'RO',
  },
  {
    key: 'Russia',
    dialCode: '+7',
    value: 'RU',
  },
  {
    key: 'Rwanda',
    dialCode: '+250',
    value: 'RW',
  },
  {
    key: 'Reunion',
    dialCode: '+262',
    value: 'RE',
  },
  {
    key: 'Saint Barthelemy',
    dialCode: '+590',
    value: 'BL',
  },
  {
    key: 'Saint Helena, Ascension and Tristan Da Cunha',
    dialCode: '+290',
    value: 'SH',
  },
  {
    key: 'Saint Kitts and Nevis',
    dialCode: '+1869',
    value: 'KN',
  },
  {
    key: 'Saint Lucia',
    dialCode: '+1758',
    value: 'LC',
  },
  {
    key: 'Saint Martin',
    dialCode: '+590',
    value: 'MF',
  },
  {
    key: 'Saint Pierre and Miquelon',
    dialCode: '+508',
    value: 'PM',
  },
  {
    key: 'Saint Vincent and the Grenadines',
    dialCode: '+1784',
    value: 'VC',
  },
  {
    key: 'Samoa',
    dialCode: '+685',
    value: 'WS',
  },
  {
    key: 'San Marino',
    dialCode: '+378',
    value: 'SM',
  },
  {
    key: 'Sao Tome and Principe',
    dialCode: '+239',
    value: 'ST',
  },
  {
    key: 'Saudi Arabia',
    dialCode: '+966',
    value: 'SA',
  },
  {
    key: 'Senegal',
    dialCode: '+221',
    value: 'SN',
  },
  {
    key: 'Serbia',
    dialCode: '+381',
    value: 'RS',
  },
  {
    key: 'Seychelles',
    dialCode: '+248',
    value: 'SC',
  },
  {
    key: 'Sierra Leone',
    dialCode: '+232',
    value: 'SL',
  },
  {
    key: 'Singapore',
    dialCode: '+65',
    value: 'SG',
  },
  {
    key: 'Slovakia',
    dialCode: '+421',
    value: 'SK',
  },
  {
    key: 'Slovenia',
    dialCode: '+386',
    value: 'SI',
  },
  {
    key: 'Solomon Islands',
    dialCode: '+677',
    value: 'SB',
  },
  {
    key: 'Somalia',
    dialCode: '+252',
    value: 'SO',
  },
  {
    key: 'South Africa',
    dialCode: '+27',
    value: 'ZA',
  },
  {
    key: 'South Sudan',
    dialCode: '+211',
    value: 'SS',
  },
  {
    key: 'South Georgia and the South Sandwich Islands',
    dialCode: '+500',
    value: 'GS',
  },
  {
    key: 'Spain',
    dialCode: '+34',
    value: 'ES',
  },
  {
    key: 'Sri Lanka',
    dialCode: '+94',
    value: 'LK',
  },
  {
    key: 'Sudan',
    dialCode: '+249',
    value: 'SD',
  },
  {
    key: 'Suriname',
    dialCode: '+597',
    value: 'SR',
  },
  {
    key: 'Svalbard and Jan Mayen',
    dialCode: '+47',
    value: 'SJ',
  },
  {
    key: 'Swaziland',
    dialCode: '+268',
    value: 'SZ',
  },
  {
    key: 'Sweden',
    dialCode: '+46',
    value: 'SE',
  },
  {
    key: 'Switzerland',
    dialCode: '+41',
    value: 'CH',
  },
  {
    key: 'Syrian Arab Republic',
    dialCode: '+963',
    value: 'SY',
  },
  {
    key: 'Taiwan',
    dialCode: '+886',
    value: 'TW',
  },
  {
    key: 'Tajikistan',
    dialCode: '+992',
    value: 'TJ',
  },
  {
    key: 'Tanzania, United Republic of Tanzania',
    dialCode: '+255',
    value: 'TZ',
  },
  {
    key: 'Thailand',
    dialCode: '+66',
    value: 'TH',
  },
  {
    key: 'Timor-Leste',
    dialCode: '+670',
    value: 'TL',
  },
  {
    key: 'Togo',
    dialCode: '+228',
    value: 'TG',
  },
  {
    key: 'Tokelau',
    dialCode: '+690',
    value: 'TK',
  },
  {
    key: 'Tonga',
    dialCode: '+676',
    value: 'TO',
  },
  {
    key: 'Trinidad and Tobago',
    dialCode: '+1868',
    value: 'TT',
  },
  {
    key: 'Tunisia',
    dialCode: '+216',
    value: 'TN',
  },
  {
    key: 'Turkey',
    dialCode: '+90',
    value: 'TR',
  },
  {
    key: 'Turkmenistan',
    dialCode: '+993',
    value: 'TM',
  },
  {
    key: 'Turks and Caicos Islands',
    dialCode: '+1649',
    value: 'TC',
  },
  {
    key: 'Tuvalu',
    dialCode: '+688',
    value: 'TV',
  },
  {
    key: 'Uganda',
    dialCode: '+256',
    value: 'UG',
  },
  {
    key: 'Ukraine',
    dialCode: '+380',
    value: 'UA',
  },
  {
    key: 'United Arab Emirates',
    dialCode: '+971',
    value: 'AE',
  },
  {
    key: 'United Kingdom',
    dialCode: '+44',
    value: 'GB',
  },
  {
    key: 'United States',
    dialCode: '+1',
    value: 'US',
  },
  {
    key: 'Uruguay',
    dialCode: '+598',
    value: 'UY',
  },
  {
    key: 'Uzbekistan',
    dialCode: '+998',
    value: 'UZ',
  },
  {
    key: 'Vanuatu',
    dialCode: '+678',
    value: 'VU',
  },
  {
    key: 'Venezuela, Bolivarian Republic of Venezuela',
    dialCode: '+58',
    value: 'VE',
  },
  {
    key: 'Vietnam',
    dialCode: '+84',
    value: 'VN',
  },
  {
    key: 'Virgin Islands, British',
    dialCode: '+1284',
    value: 'VG',
  },
  {
    key: 'Virgin Islands, U.S.',
    dialCode: '+1340',
    value: 'VI',
  },
  {
    key: 'Wallis and Futuna',
    dialCode: '+681',
    value: 'WF',
  },
  {
    key: 'Yemen',
    dialCode: '+967',
    value: 'YE',
  },
  {
    key: 'Zambia',
    dialCode: '+260',
    value: 'ZM',
  },
  {
    key: 'Zimbabwe',
    dialCode: '+263',
    value: 'ZW',
  },
];
